export class ItemFile {
  id: number;
  dateUploaded: Date;
  hashMD5: string;
  name: string;
  typeItemFile: TypeItemFileEnum;
  typeUseItem: TypeUseItemEnum;
  size: number;
  strictSync: boolean;
}

export enum TypeItemFileEnum {
  Folder,
  File,
}

export enum TypeUseItemEnum {
  None,
  InteriorElements,
  Textures,
  BaseMaterial,
  Composition,
  DumpBaseMaterial,
  BaseMaterialTextures,
  Scripts,
}
